import { TFunction } from 'i18next';
import { WizardStepConfig } from '../../common/types';
import * as Icon from '../../components/icons';
import {
  DashboardGroupState,
  DashboardOrder,
  DashboardViewMode,
  WarehouseDashboardMenuItemId,
} from './dashboard.types';
// Import mock data from separated files
import {
  mockFatigueMetrics,
  mockHiddenCosts,
  mockInventoryMetrics,
  mockLaborMetrics,
  mockPicklistMetrics,
  mockProcessCosts,
  mockProductivityMetrics,
  mockUOMMetrics,
} from './mockData';

export const WAREHOUSE_DASHBOARD_ITEMS_COUNT = 20;

export function getDefaultWarehouseDashboardState(): DashboardGroupState {
  return {
    viewMode: DashboardViewMode.card,
    order: DashboardOrder.updatedDesc,
    autoUpdate: true,
    page: {
      skip: 0,
      limit: WAREHOUSE_DASHBOARD_ITEMS_COUNT,
    },
  };
}

export const warehouseDashboardMenuItems: (
  t: TFunction<'app'>,
) => WizardStepConfig<WarehouseDashboardMenuItemId>[] = t => [
  {
    id: 'warehouse-dashboard-summary',
    title: t('Summary', { ns: 'app' }),
    titleMinimized: t('Summary', { ns: 'app' }),
    disabled: false,
    icon: Icon.ViewGraph,
    menuLevel: 1,
    description: t('Overview of key warehouse metrics', { ns: 'app' }),
  },
  {
    id: 'warehouse-dashboard-compare',
    title: t('Compare', { ns: 'app' }),
    titleMinimized: t('Compare', { ns: 'app' }),
    disabled: false,
    icon: Icon.Compare,
    // icon: Icon.ViewGraph,
    menuLevel: 1,
    description: t('Compare metrics across warehouses', { ns: 'app' }),
  },
  // {
  //   id: 'warehouse-dashboard-today',
  //   title: t('Today'),
  //   titleMinimized: t('Today'),
  //   disabled: false,
  //   icon: Icon.DataStatsPie,
  //   menuLevel: 1,
  //   description: t('Real-time metrics and daily targets', { ns: 'app' }),
  // },
  {
    id: 'warehouse-dashboard-process',
    title: t('Process', { ns: 'app' }),
    titleMinimized: t('Process', { ns: 'app' }),
    disabled: false,
    icon: Icon.AgentRunning,
    menuLevel: 1,
    description: t('Process efficiency and cost analysis', { ns: 'app' }),
  },
  // {
  //   id: 'warehouse-dashboard-inventory',
  //   title: t('Inventory'),
  //   titleMinimized: t('Inventory'),
  //   disabled: false,
  //   icon: Icon.DataItems,
  //   menuLevel: 1,
  //   description: t('Stock levels and SKU metrics', { ns: 'app' }),
  // },
  // {
  //   id: 'warehouse-dashboard-labour',
  //   title: t('Labour'),
  //   titleMinimized: t('Labour'),
  //   disabled: false,
  //   icon: Icon.SimulationWorkforce,
  //   menuLevel: 1,
  //   description: t('Workforce productivity and scheduling', { ns: 'app' }),
  // },
  // {
  //   id: 'warehouse-dashboard-clients',
  //   title: t('Clients'),
  //   titleMinimized: t('Clients'),
  //   disabled: false,
  //   icon: Icon.DeliveryLastMile,
  //   menuLevel: 1,
  //   description: t('Client performance and SLA tracking', { ns: 'app' }),
  // },
  // {
  //   id: 'warehouse-dashboard-insights',
  //   title: t('Insights'),
  //   titleMinimized: t('Insights'),
  //   disabled: false,
  //   icon: Icon.CongestionMapCircles,
  //   menuLevel: 1,
  //   description: t('Analytics and trend analysis', { ns: 'app' }),
  // },
  // {
  //   id: 'warehouse-dashboard-issues',
  //   title: t('Issues'),
  //   titleMinimized: t('Issues'),
  //   disabled: false,
  //   icon: Icon.PolicyComplianceSafety,
  //   menuLevel: 1,
  //   description: t('Problem tracking and resolution'),
  // },
  // {
  //   id: 'warehouse-dashboard-compliance',
  //   title: t('Compliance'),
  //   titleMinimized: t('Compliance'),
  //   disabled: false,
  //   icon: Icon.PolicyCompliancePreview,
  //   menuLevel: 1,
  //   description: t('Regulatory compliance and audits', { ns: 'app' }),
  // },
  // {
  //   id: 'warehouse-dashboard-projects',
  //   title: t('Projects'),
  //   titleMinimized: t('Projects'),
  //   disabled: false,
  //   icon: Icon.PredictTime,
  //   menuLevel: 1,
  //   description: t('Projects dashboard views', { ns: 'app' }),
  // },

  // {
  //   id: 'warehouse-dashboard-heatmaps',
  //   title: t('Heatmaps'),
  //   titleMinimized: t('Heatmaps'),
  //   disabled: false,
  //   icon: Icon.HeatMap9,
  //   menuLevel: 1,
  //   description: t('Heatmaps', { ns: 'app' }),
  // },
  // {
  //   id: 'warehouse-dashboard-custom',
  //   title: t('Custom...'),
  //   titleMinimized: t('Custom'),
  //   disabled: false,
  //   icon: Icon.HeatMap9,
  //   menuLevel: 1,
  //   description: t('Customizable dashboard views', { ns: 'app' }),
  // },
];

// Export all mock data to maintain backward compatibility
export {
  mockFatigueMetrics,
  mockHiddenCosts,
  mockInventoryMetrics,
  mockLaborMetrics,
  mockPicklistMetrics,
  mockProcessCosts,
  mockProductivityMetrics,
  mockUOMMetrics,
};
